import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { FullPageLoader } from "./components";

export interface PublicLoginRouterProps {}

export enum EPublicLoginRoutes {
  login = "/login",
  signUp = "/signup",
  recoverPassword = "/lost-password",
  manager = "/manager",
  mailVerification = "/mailVerification",
}

const LoginPage = React.lazy(() => import("./pages/public/login/LoginPage"));
const SignUpPage = React.lazy(() => import("./pages/public/login/SignUpPage"));
const RecoverPasswordPage = React.lazy(
  () => import("./pages/public/login/RecoverPasswordPage")
);

const EmailVerificationPage = React.lazy(
  () => import("./pages/public/login/EmailVerificationPage")
);

export const PublicLoginRouter: React.FC<PublicLoginRouterProps> = ({}) => {
  return (
    <React.Suspense fallback={<FullPageLoader fullHeight={false} />}>
      <Switch>
        <Route
          path={`${EPublicLoginRoutes.login}/:redirect?`}
          component={LoginPage}
        />
        <Route path={`${EPublicLoginRoutes.signUp}`} component={SignUpPage} />
        <Route
          path={`${EPublicLoginRoutes.recoverPassword}/:token?`}
          component={RecoverPasswordPage}
        />
        <Route
          path={`${EPublicLoginRoutes.manager}/:userId/:token`}
          component={SignUpPage}
        />
        <Route
          path={`${EPublicLoginRoutes.mailVerification}/:token`}
          component={EmailVerificationPage}
        />
        <Redirect to={EPublicLoginRoutes.login} />
      </Switch>
    </React.Suspense>
  );
};
